
import { defineComponent, ref, computed } from "vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "reset-password-modal",
  components: {},
  setup() {
    const submitButtonRef = ref<null | HTMLButtonElement>(null);
    const modalRef = ref<null | HTMLElement>(null);
    const changePasswordModalRef = ref<null | HTMLElement>(null);
    const store = useStore();
    const lineUrl = computed(() => {
      return store.getters.currentCompanyLineUrl;
    });
    const lineId = computed(() => {
      return store.getters.currentCompanyLineId;
    });
    const lineQrCodeUrl = computed(() => {
      return store.getters.currentLineQrCodeUrl;
    });
    return {
      submitButtonRef,
      modalRef,
      changePasswordModalRef,
      lineUrl,
      lineId,
      lineQrCodeUrl,
    };
  },
});
